import cx from 'classnames';
import { useState } from 'react';
import { Announcement, Navbar, Sidebar, Spacer } from '../../components';
export default function TrueHolder() {
  const [closeSide, setCloseSide] = useState(false)
  const [ann, setAnn] = useState(true)
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })
  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
        <div className="container-fluid">
            <Spacer h={20} />
            {
              ann && <Announcement
                message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
                onClick={() => setAnn(false)}
                varian="dark"
              />
            }
            <div className="cardContainer">
              <span className="d-block">
                The app tracks true NFT holder and check token distribution status whether it is fairly distributed or token majority is hold by the creator/ using different wallets.
                </span>
              <span className="d-block">Having this information will prevent potential buyer from engineered price floor by the creator.</span>
              <span className="d-block">Supported network: BSC, ETH, Polygon, Avalanche and Arbitrum.</span>
            </div>
            <Spacer h={20} />
            <div className="cardContainer">
            <video className="img-fluid" controls src="/media/trueholder.m4v" />
            </div>
              <Spacer h={20} />
            </div>
        </div>
      </div>
    </div>
  )
}
